import http from '../util/ws/wsService.js'

class EntityServise {
    constructor(routeApi) {
        this.routeApi = routeApi
    }

    routeApi;
    http = http;

    async insertOrUpdate(entity) {

        return entity.id ? await http.put(this.routeApi, entity) : await http.post(this.routeApi, entity);
    }

    async delete(id) {
        return await http.delete(this.routeApi, id);
    }

    async getAll(page, limit, search, searchFields) {
        if (search && search.length > 0 && searchFields && searchFields.length > 0) {
            return await this.search(searchFields, search, page, limit);
        }
        return await http.get(this.routeApi, { page, limit });
    }

    async search(fields, search, page, limit) {
        fields = fields.toString()
        return await http.get(this.routeApi + "/search-fields", { fields, search, page, limit });
    }

    async getById(id) {
        //console.log("job", await http.get(this.routeApi + "/s-id", { id }) );
        return await http.get(this.routeApi + "/s-id", { id });
    }

}

export default EntityServise;